import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type AuthResponse, browserTimezone, clearViewer, setViewer } from '@/entities/viewer';
import { api } from '@/shared/api';
import { i18n, isLocale } from '@/shared/i18n';

import type { LoginValues, RegisterValues } from './schemas';

export function useLogin() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (values: LoginValues) => api.post<AuthResponse>('/v1/auth/login', values),
    onSuccess: (auth) => {
      setViewer(client, auth);
    },
  });
}

export function useRegister() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (values: RegisterValues) =>
      api.post<AuthResponse>('/v1/auth/register', {
        ...values,
        // The UI language and the browser timezone become the account's defaults.
        locale: isLocale(i18n.language) ? i18n.language : undefined,
        timezone: browserTimezone(),
      }),
    onSuccess: (auth) => {
      setViewer(client, auth);
    },
  });
}

export function useLogout() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: () => api.post('/v1/auth/logout'),
    // Even if the request fails, the local session view must be dropped.
    onSettled: () => {
      clearViewer(client);
    },
  });
}
